import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from "classnames";
import TextInput from "../../FormComponents/TextInput";
import { useState } from "react";
import servicesUtils from "../../../utils/servicesUtils";
import Toast from "../../Toast";
import useBulkCsvUpload from "../../../hooks/useBulkCsvUpload";
import useAdminView from "../../../hooks/useAdminView";
function AddUser(_ref) {
  var workspace = _ref.workspace;
  var _useAdminView = useAdminView(),
    _useAdminView2 = _slicedToArray(_useAdminView, 2),
    dispatch = _useAdminView2[1];
  var _useBulkCsvUpload = useBulkCsvUpload(),
    _useBulkCsvUpload2 = _slicedToArray(_useBulkCsvUpload, 2),
    csvUploadDispatch = _useBulkCsvUpload2[1];
  var _useState = useState({
      username: "",
      email: ""
    }),
    formData = _useState[0],
    setFormData = _useState[1];
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var payload, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.p = 0;
            e.preventDefault();
            e.stopPropagation();
            payload = {
              username: formData.username,
              email: formData.email
            };
            _context.n = 1;
            return servicesUtils.postService("workspaces/".concat(workspace.value, "/site/user/create/"), payload);
          case 1:
            response = _context.v;
            dispatch({
              type: "get-data"
            });
            csvUploadDispatch({
              type: "hide-modal"
            });
            setFormData({
              username: "",
              email: ""
            });
            Toast.success("User added successfully");
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            Toast.error("Error while adding user");
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full flex flex-col p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center space-x-3 text-gray-500"
  }, /*#__PURE__*/React.createElement("span", null, "Workspace:"), /*#__PURE__*/React.createElement("span", {
    className: "font-semibold text-gray-300"
  }, workspace === null || workspace === void 0 ? void 0 : workspace.label))), /*#__PURE__*/React.createElement("div", {
    className: "grow flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-md mt-5 p-3 w-[60%] mx-auto"
  }, /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: handleSubmit,
    className: "rounded-md p-5 space-y-7 flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-5"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Username",
    name: "username",
    id: "username",
    placeholder: "Enter username",
    required: true,
    value: formData.username,
    onChange: function onChange(value) {
      setFormData(_objectSpread(_objectSpread({}, formData), {}, {
        username: value
      }));
    },
    labelClassName: "!bg-gray-900"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Email",
    name: "email",
    id: "email",
    placeholder: "Enter email",
    required: true,
    value: formData.email,
    onChange: function onChange(value) {
      setFormData(_objectSpread(_objectSpread({}, formData), {}, {
        email: value
      }));
    },
    labelClassName: "!bg-gray-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames("px-7 py-3 bg-teal-500 hover:bg-teal-600 rounded-md", "disabled:opacity-50 disabled:cursor-not-allowed"),
    type: "submit",
    disabled: !formData.username || !formData.email
  }, "Submit"))))));
}
export default AddUser;